var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0248 0C13.4219 0 0 13.7499 0 30.7605C0 44.3579 8.59985 55.8679 20.5301 59.9416C22.0217 60.2479 22.5681 59.2798 22.5681 58.4654C22.5681 57.7523 22.5189 55.3079 22.5189 52.761C14.1667 54.5948 12.4275 49.0942 12.4275 49.0942C11.0852 45.5292 9.09644 44.6129 9.09644 44.6129C6.36277 42.7286 9.29556 42.7286 9.29556 42.7286C12.3279 42.9323 13.9191 45.8861 13.9191 45.8861C16.603 50.571 20.9278 49.2473 22.6677 48.4323C22.9159 46.4461 23.7118 45.0711 24.5569 44.3073C17.8954 43.5942 10.8867 40.9461 10.8867 29.1305C10.8867 25.7693 12.079 23.0193 13.9682 20.8805C13.6702 20.1168 12.626 16.9587 14.2669 12.7318C14.2669 12.7318 16.8021 11.9168 22.5183 15.8893C24.9656 15.216 27.4895 14.8734 30.0248 14.8706C32.56 14.8706 35.1443 15.2274 37.5307 15.8893C43.2476 11.9168 45.7827 12.7318 45.7827 12.7318C47.4237 16.9587 46.3789 20.1168 46.0808 20.8805C48.0198 23.0193 49.1629 25.7693 49.1629 29.1305C49.1629 40.9461 42.1542 43.5429 35.443 44.3073C36.5369 45.2748 37.4809 47.1079 37.4809 50.011C37.4809 54.136 37.4318 57.4466 37.4318 58.4648C37.4318 59.2798 37.9788 60.2479 39.4697 59.9423C51.4 55.8673 59.9999 44.3579 59.9999 30.7605C60.049 13.7499 46.578 0 30.0248 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.44c22e0b78767592a70f59321e4ee713.svg";
export { ForwardRef as ReactComponent };